<script>
  import { onMount } from 'svelte'

  const init = () => {
    var iframe = document.getElementById( 'api-frame' );
    var uid = '8a3f54a498f24a889852e14917e9a614';

    // By default, the latest version of the viewer API will be used.
    var client = new Sketchfab( iframe );

    // Alternatively, you can request a specific version.
    // var client = new Sketchfab( '1.9.0', iframe );

    client.init( uid, {
        success: function onSuccess( api ){
            api.start();
            api.addEventListener( 'viewerready', function() {

                // API is ready to use
                // Insert your code here
                console.log( 'Viewer is ready' );

            } );
        },
        error: function onError() {
            console.log( 'Viewer error' );
        }
    } );
  }


</script>

<svelte:head>
  <script type="text/javascript" src="https://static.sketchfab.com/api/sketchfab-viewer-1.9.0.js" on:load={ init }></script>
</svelte:head>

<iframe title="" src="" id="api-frame" allow="autoplay; fullscreen; vr" allowvr allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true">
</iframe>

<style lang="scss">
  iframe {
    width: 100%;
    height: 35vmin;
    border-radius: 20px;
    @include media-small {
      border-radius: 15px;
    }
  }
</style>

